import { Button, Flex, Icon, Skeleton, Text } from '@tonic-one/react';
import { ChevronRightIcon, EmailOIcon } from '@tonic-one/react-icons';
import { t } from 'i18next';

interface EmailHeaderProps {
  isLoading: boolean;
  msgSubject: string;
  onViewEmailClick: () => void;
}

export const EmailHeader = ({
  isLoading,
  msgSubject,
  onViewEmailClick,
}: EmailHeaderProps) => {
  if (isLoading) {
    return (
      <Flex alignItems="center" gap="4x">
        <Skeleton height="8x" width="400px" animation="wave" />
      </Flex>
    );
  }

  return (
    <Flex alignItems="center" gap="4x">
      <Flex alignItems="center" gap="2x">
        <Icon as={EmailOIcon} size="4x" />
        <Text
          size="lg"
          fontWeight={500}
          wordBreak="break-word"
          whiteSpace="normal"
        >
          {msgSubject}
        </Text>
      </Flex>
      <Button
        variant="secondary"
        borderRadius={24}
        onClick={onViewEmailClick}
        gap="2x"
      >
        {t('operations.euq.email.viewEmail')}
        <ChevronRightIcon size="3x" />
      </Button>
    </Flex>
  );
};
